import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github, Facebook } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="text-2xl font-heading font-bold text-gradient mb-4">CodeSky</div>
            <p className="text-slate-600 text-sm mb-6">
              Professional software development company delivering innovative solutions for startups and enterprises.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/codesky-in/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-600 hover:text-primary transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>

              <a href="/" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="/" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-github">
                <Github className="w-5 h-5" />
              </a>
              <a href="/" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-slate-900 mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/web-development" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  Web Development
                </Link>
              </li>
              <li>
                <Link to="/services/mobile-development" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  Mobile Development
                </Link>
              </li>
              <li>
                <Link to="/services/seo-marketing" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  SEO & Marketing
                </Link>
              </li>
              <li>
                <Link to="/services/uiux-design" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  UI/UX Design
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-slate-900 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-600 hover:text-primary transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-slate-900 mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-slate-600">
                <Mail className="w-4 h-4 mt-0.5" />
                <span>info.codesky@gmail.com</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-slate-600">
                <Phone className="w-4 h-4 mt-0.5" />
                <span>+91 8989532237</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-slate-600">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>Navi Mumbai, Maharashtra – 400703</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-12 pt-8 text-center text-sm text-slate-600">
          <p>© {new Date().getFullYear()} CodeSky. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
